<template>
  <div class="container">
    <div class="head">
      <div class="head-title">规章制度</div>
      <div @click="$router.push({ name: 'rulers', query: { type: 3 } })" class="head-more">更多 >></div>
    </div>
    <ul class="list">
      <li @click="openDetail(item)" v-for="item in list" :key="item" class="list-item">
        <div class="list-item-title">{{item.headline}}</div>
        <div class="list-item-date">{{item.addTime}}</div>
      </li>
    </ul>
  </div>
</template>

<script>
import { http } from '@/utils/http'

export default {
  data() {
    return {
      list: [],
      loading: true,
      total: 0,
      pageNum: 1
    }
  },
  created() {
    this.onload()
  },
  methods: {
    onload() {
      let parameter = {
        pageNum: this.pageNum,
        pageSize: 3,
        type: 3
      }
      this.loading = true
      this.list = []
      http('/system/announcement/getList', 'POST', parameter).then(res => {
        this.loading = false
        if (res.success) {
          this.list = res.data.resultList
          this.total = res.data.total
        }
      })
    },
    openDetail(item) {
      let url = this.$router.resolve({ name: 'rulers', query: { noticeId: item.id, type: 3 } })
      window.open(url.href, '_blank')
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  background-color: #fff;
  box-sizing: border-box;
}
.list {
  padding-left: 0;
  list-style-type: none;
  margin-top: 5px;
  &-item {
    width: 100%;
    height: 40px;
    line-height: 40px;
    overflow: hidden;
    border-bottom: 1px dotted #dfdfdf;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0 10px 15px;
    cursor: pointer;
    position: relative;
    &::before {
      content: '';
      display: block;
      position: absolute;
      top: 18px;
      left: 0;
      width: 4px;
      height: 4px;
      background-color: #005d86;
    }
    &-title {
      width: 250px;
      letter-spacing: 1px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: #5a5a5a;
      transition: .2s;
    }
    &-date {
      font-size: 13px;
      color: #a5a5a5;
    }
    &:hover .list-item-title {
      color: #96cdff; 
    }
  }
}
</style>